export class LoggedIn {

    private _current = $state(false)
    get current() { return this._current }

    public change(loggedInState: boolean) {
        this._current = loggedInState;
    }
}